function debounce(fn, delay = 300) {
  let timer = null;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

let scarfRingAdding = false;

// const onCartChangeDebounced = debounce(async (e) => {
//   const cart = e.detail?.cart;
//   if (!cart?.items) return;

//   if (e.detail.cart?.items_removed?.length > 0) {
//     if (
//       e.detail.cart.items_removed[0].product_id ==
//       window.themeVariables.products.scarfRing.id
//     ) {
//       sessionStorage.setItem("scarfRingRemoved", true);
//       return;
//     }
//   }

//   const has_scarf = cart.items.some((item) =>
//     item.properties?._tags_2?.split(",").includes("Foulard"),
//   );

//   const has_scarf_ring = cart.items.some(
//     (item) => item.handle === "anneaux-infini-dore",
//   );

//   if (has_scarf_ring) return;
//   if (!has_scarf) return;

//   if (scarfRingAdding) return; // ✅ prevents double-add
//   scarfRingAdding = true;

//   try {
//     if (sessionStorage.getItem("scarfRingRemoved") != "true") {
//       await window.addToCart(
//         window.themeVariables.products.scarfRing.variants[0].id,
//       );
//     }
//   } finally {
//     scarfRingAdding = false;
//   }
// }, 1000);

// document.documentElement.addEventListener("cart:change", onCartChangeDebounced);
// document.documentElement.addEventListener(
//   "line-item:change",
//   onCartChangeDebounced,
// );

window.addToCart = async function addToCart(variantId, quantity = 1) {
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    }),
  );
  const formData = new FormData();
  formData.set("id", variantId); // ID de la variante à ajouter
  formData.set("quantity", 1); // Quantité (par défaut 1)
  formData.set("sections", sectionsToBundle.join(","));
  formData.set("sections_url", `${Shopify.routes.root}variants/${variantId}`);

  // Envoyer la requête POST
  const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
    method: "POST",
    body: formData,
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  });

  const responseJson = await response.json();

  // Si l'ajout au panier est réussi
  if (response.ok) {
    if (
      window.themeVariables.settings.cartType === "page" ||
      window.themeVariables.settings.pageType === "cart"
    ) {
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }

    // Récupérer les données du panier
    const cartContent = await (
      await fetch(`${Shopify.routes.root}cart.js`)
    ).json();
    cartContent["sections"] = responseJson["sections"];

    // Déclencher des événements personnalisés
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent,
        },
      }),
    );
  } else {
    // Gérer les erreurs
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:error", {
        bubbles: true,
        detail: {
          error: responseJson["description"],
        },
      }),
    );
  }
};

if (!customElements.get("variant-media")) {
  class VariantMedia extends HTMLElement {
    constructor() {
      super();

      document.addEventListener("variant:change", (e) => {
        const { variant } = e.detail;
        this.handleUpdateMedia(variant);
      });
    }

    handleUpdateMedia(variant) {
      const image = variant.featured_image.src;

      const imageEl = this.querySelector("img");
      imageEl.src = image;
      imageEl.alt = variant.featured_image.alt;
      imageEl.removeAttribute("srcset");
    }
  }

  customElements.define("variant-media", VariantMedia);
}
